<template>
    <app-layout>
        <form @submit.prevent="upsertUser">
            <base-header :shadow="false" border border-bg-from="from-sky-500" border-bg-to="to-indigo-500" :back-url="route('users.index')">
                <div>
                    <div class="text-xl font-bold">
                        <span v-if="form.name">
                            {{ form.name }}
                        </span>
                        <element-placeholder width="w-96" v-else/>
                    </div>
                    <div class="opacity-50">
                        <span v-if="form.email" class="flex items-center">
                            <icon name="mail" class="mr-2"/> {{ form.email }}
                        </span>
                        <template v-else>
                            <element-placeholder height="h-4" width="w-48" class="mt-1"/>
                        </template>
                    </div>
                </div>

                <div class="flex items-center">
                    <default-button icon="save" size="sm" type="submit">
                        {{ $t('form.submit') }}
                    </default-button>
                </div>
            </base-header>

            <base-content>
                <div class="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6 items-start">
                    <div class="grid grid-cols-1 gap-6">
                        <div>
                            <base-card>
                                <template #header>
                                    {{ $t('general.user') }}
                                </template>
                                <template #body>
                                    <div class="space-y-4">
                                        <input-group v-model="form.name" name="name" :label="$t('general.name')"
                                                     :form="form" required/>
                                        <input-group v-model="form.email" name="email" :label="$t('general.email')"
                                                     type="email" :form="form" required/>
                                        <div class="sm:grid sm:grid-cols-2 sm:gap-4">
                                            <input-group v-model="form.password" name="password" type="password"
                                                         :label="$t('auth.password')" :form="form"/>
                                            <input-group v-model="form.password_confirmation" name="password_confirmation" type="password"
                                                         :label="$t('auth.password_confirmation')" :form="form"/>
                                        </div>
                                    </div>
                                </template>
                                <template #footer>
                                    <div class="space-y-2">
                                        <toggle v-model="form.active" name="active" :label="$t('user.active')"
                                                :help="$t('user.active_help')" :form="form"
                                                active-color="bg-green-400 dark:bg-green-600"/>
                                        <toggle v-model="form.is_admin" id="admin" label="Admin" name="is_admin"
                                                :help="$t('user.admin_help')"
                                                active-color="bg-green-400 dark:bg-green-600"/>
                                    </div>
                                </template>
                            </base-card>
                        </div>
                    </div>
                    <div class="grid grid-cols-1 gap-6">
                        <div class="space-y-4">
                            <base-card>
                                <template #header>
                                    {{ $t('general.stores') }}
                                </template>
                                <template #body>
                                    <multiselect v-model="storeSelected" label="name" track-by="id" @input="addStore"
                                                 :options="stores.filter(store => !form.stores.includes(store))"
                                    />

                                    <div class="mt-4 space-y-2" v-if="form.stores.length > 0">
                                        <div class="w-full flex items-center justify-between" v-for="store in form.stores" :key="store.id">
                                            <span>{{ store.name }}</span>
                                            <span>
                                                <default-button icon="x-circle" :label="$t('form.delete')"
                                                                size="xs" color="red" @click.native="removeStore(store)"/>
                                            </span>
                                        </div>
                                    </div>
                                </template>
                            </base-card>
                        </div>
                    </div>
                </div>
            </base-content>
        </form>
    </app-layout>
</template>

<script>
import DeleteButton from '@/Components/Button/DeleteButton';
export default {
    components: {DeleteButton},
    props: {
        stores: Array,
        editUser: {
            type: Object,
            default: null,
        },
    },

    data() {
        return {
            storeSelected: null,

            form: this.$inertia.form({
                name: this.editUser?.name ?? null,
                email: this.editUser?.email ?? null,
                password: null,
                password_confirmation: null,
                active: this.editUser?.active ?? false,
                is_admin: this.editUser?.is_admin ?? false,
                stores: this.editUser?.stores ?? [],
            }, {
                bag: 'user',
            }),
        };
    },

    computed: {
        permissionGroups() {
            return this.permissions.reduce((carry, permission) => {
                let groupName = _.startCase(permission.name.split('.')[0]);

                if (!carry.hasOwnProperty(groupName)) {
                    carry[groupName] = [];
                }

                carry[groupName].push(permission);

                return carry;
            }, {});
        },
    },

    methods: {
        addStore(store) {
            if (!store || this.form.stores.includes(store)) {
                return;
            }

            this.form.stores.push(store);
            this.form.stores.sort((a, b) => a.number - b.number);
            this.storeSelected = null;
        },
        removeStore(store) {
            this.form.stores?.splice(this.form.stores?.findIndex(otherStore => store.id === otherStore.id), 1);
        },
        upsertUser() {
            this.form.transform(data => {
                return {
                    ...data,
                    stores: data.stores.map(store => store.id),
                };
            });

            if (this.editUser) {
                this.form.put(route('users.update', this.editUser.id), {
                    preserveScroll: true,
                });
            } else {
                this.form.post(route('users.store'), {
                    preserveScroll: true,
                });
            }
        },
        getPermissionTranslation(name) {
            return this.$t('permission.' + name.split('.').splice(1).join('.'));
        },
    },
};
</script>
